import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

export default function LineChartComponent({ data }) {
  return (
    <LineChart
      xAxis={[
        {
          scaleType: "point",
          data: data.map((item) => item.date),
        },
      ]}
      series={[
        {
          data: data.map((item) => item.completedTasks),
          valueFormatter: (value) => `${value}%`,
          label: "درصد عملکرد بازیکنان",
        },
        {
          data: data.map((item) => item.pendingTasks),
          valueFormatter: (value) => `${value}%`,
          label: "درصد رضایت بازیکنان",
        },
      ]}
      grid={{ vertical: true, horizontal: true }}
      height={400}
    />
  );
}
